import styled from 'styled-components';

export const Container = styled.button`
  width: 200px;
  height: 32px;
  @media (min-width: 768px) {
    width: 200px;
    height: 32px;
  }
  cursor: pointer;
  align-items: center;
  justify-content: center;

  background-color: ${(props) => props.theme.colors.primary};
  padding: 0px 15px;
  border-radius: 50px;
  border: none;
  color: ${(props) => props.theme.colors.lighterText};
  font-family: ${(props) => props.theme.fonts.primaryFont};
  opacity: 0.8;
  :hover {
    ${({ theme, disabled }) =>
      !disabled
        ? `
      opacity: 1;
      box-shadow: 0 5px 5px rgba(0, 0, 0, 0.1);
      background: linear-gradient(
        90deg,
        ${theme.colors.primary} 35%,
        ${theme.colors.secondary} 100%
      );`
        : null}
  }
  :focus {
    outline: 0;
  }
  transition: opacity 400ms ease-in-out;

  :disabled {
    background-color: ${({ theme }) => theme.colors.border};
  }
`;

export const Title = styled.p`
  font-family: ${(props) => props.theme.fonts.primaryFont};
  font-weight: 400;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;

  font-size: 15px;
  @media (min-width: 768px) {
    font-size: 15px;
  }
  color: ${(props) => props.theme.colors.lighterText};
`;
